export type CacheFailureReason = "download" | "quota" | "registration" | "unknown";

export const PWA_CACHE_FAILURE_MESSAGE_TYPE = "PWA_CACHE_FAILURE";
export const PWA_UPDATE_RESCUE_ACK_MESSAGE_TYPE = "PWA_UPDATE_RESCUE_ACK";
export const PWA_UPDATE_RESCUE_PROBE_MESSAGE_TYPE = "PWA_UPDATE_RESCUE_PROBE";

export const CACHE_FAILURE_MESSAGES: Readonly<Record<CacheFailureReason, string>> = {
  download: "有些离线内容暂时没有保存，请联网后再试一次。",
  quota: "设备空间不够，离线内容没有全部保存。",
  registration: "离线内容暂时没有准备好，请联网后再试一次。",
  unknown: "离线内容没有全部保存，请联网后再试一次。"
};

export interface PwaStatusSnapshot {
  readonly isOnline: boolean;
  readonly isOfflineReady: boolean;
  readonly isUpdateAvailable: boolean;
  readonly isUpdateSafe: boolean;
  readonly isApplyingUpdate: boolean;
  readonly cacheFailureMessage: string | null;
}

export interface ServiceWorkerRegistrationCallbacks {
  onNeedRefresh(): void;
  onOfflineReady(): void;
  onRegisterError(error: unknown): void;
}

export interface PwaRegistrationHandle {
  applyUpdate(): Promise<void>;
  checkForUpdate(): Promise<void>;
}

export type RegisterPwaServiceWorker = (
  callbacks: ServiceWorkerRegistrationCallbacks
) => PwaRegistrationHandle;

export interface PwaEnvironment {
  isOnline(): boolean;
  reloadPage(): void;
  subscribeToConnectivity(onOnline: () => void, onOffline: () => void): () => void;
  subscribeToVisibility(onVisible: () => void): () => void;
  subscribeToServiceWorkerMessages(listener: (data: unknown) => void): () => void;
}

export function readCacheFailureReason(data: unknown): CacheFailureReason | null {
  if (typeof data !== "object" || data === null) {
    return null;
  }

  if (Reflect.get(data, "type") !== PWA_CACHE_FAILURE_MESSAGE_TYPE) {
    return null;
  }

  const reason = Reflect.get(data, "reason");

  switch (reason) {
    case "download":
    case "quota":
    case "registration":
    case "unknown":
      return reason;
    default:
      return "unknown";
  }
}
